<template>
    <div class="card animated2s fadeIn col-11 col-md-5 mb-4 mb-md-4">
        <div class="row no-gutters align-items-center my-2 mt-md-4 mb-md-0">
            <div class="col-2 d-flex justify-content-start align-items-center">
                <img class="img-fluid race-track-icon"
                    :src="getImage(raceCourseAssets[race.raceTrackAssetId].raceTrackIcon)"/>
            </div>
            <div class="col-8 text-center">
                <div class="row no-gutters flex-nowrap justify-content-around align-items-center">
                <div class="race-course-logo-title-wrapper">
                    <h1 v-if="!showRaceCourseLogoTitle" class="race-track-card-text race-track-title race-track-main-title col-12 font-weight-bold">{{race.courseTitle}}</h1>

                        <img v-else :src="getImage(raceCourseAssets[race.raceTrackAssetId].raceCourseTitleLogoBlackPath, 'svg')" class="race-course-logo-title" />
                    </div>
                </div>
                <div class="row no-gutters flex-nowrap justify-content-around align-items-center">
                    <span class="race-track-card-text race-track-title text col-12 font-weight-bold">{{race.courseSubTitle}}</span>
                </div>
            </div>
        </div>
        <div class="row no-gutters justify-content-space-evenly align-items-center">
            <div class="col-6">
                <div class="row race-date-time no-gutters flex-nowrap">
                    <div class="col-12">
                        <div class="row no-gutters flex-nowrap">
                            <span class="race-track-card-text font-italic text flex-nowrap">{{race.raceDate}}</span>
                        </div>
                        <div class="row no-gutters flex-nowrap">
                            <span class="race-track-card-text font-italic text flex-nowrap">{{race.raceTime | timetocolon}}</span>
                        </div>
                        <div class="row no-gutters flex-nowrap">
                            <span class="race-track-card-text font-italic text flex-nowrap">{{race.raceCount}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-5 col-md-4 col-lg-3">
                <div class="race-track-image-wrapper">
                    <img class="race-track-image" :src="getImage(raceCourseAssets[race.raceTrackAssetId].raceCourseIcon)"/>
                </div>
            </div>
        </div>
        <!--            <div class="col-12 col-md-7 mt-md-4 d-flex justify-content-center align-items-center">-->
        <!--                <div class="row no-gutters">-->
        <!--                    <span class="col-12 race-track-card-text font-italic text font-weight-bold">-->
        <!--                   {{race.descriptionHeading}}-->
        <!--                    </span>-->
        <!--                    <p>{{race.description}}<br><span class="mt-1 font-weight-bold">Read More</span></p>-->
        <!--                </div>-->
        <!--            </div>-->
        <div class="col-12">
            <!--<div class="row justify-content-start no-gutters">-->
            <!--<span class="btn">Read more...</span>-->
            <!--</div>-->
            <div class="row justify-content-around no-gutters">                
                <button v-on:click="raceCardCallback(index)" class="btn btn-dark home-button text col-5">RACECARD
                </button>                       
                <button v-on:click="statsCallback(index)" class="btn btn-dark home-button text col-5">INDEXES
                </button>
                 <!-- <button v-if="(race.courseTitle ==='Hollywoodbets Greyville')" v-on:click="goToPdfSite('https://cdpdf.hollywoodbets.net/WinningForm/WinningForm.pdf')" class="btn btn-dark home-button text col-5 ButtonPdf">RACE CARD PDF (28.7MB)
                </button> -->
            </div>
        </div>
    </div>
</template>

<script>
    import {RaceCourseAssets} from './configuration/raceCourseAssetMapping.constant';
    import {trackLogoId} from '../../config';

    export default {
        name: 'RaceCardSummary',
        props: {
            race: Object,
            raceCardCallback: Function,
            statsCallback: Function,
            index: Number
        },
        data: function () {
            return {                
                raceCourseAssets: RaceCourseAssets,
                showRaceCourseLogoTitle: false
            }
        },
        filters:{
                timetocolon:function(value){
                    value=value.toString()
                    if(value!=null && value.includes('.')){
                        value=value.replace('.',':')
                        return value
                    }
                },
        },
        methods: {
            getImage(imagePath) {
                return require('../assets/images/' + imagePath + '.svg');
            },
            goToPdfSite(url){
                window.open(url, '_blank');
            }
        },
        mounted: function() {
            const {raceTrackAssetId} = this.race;
            const showRaceCourseLogoTitleIds = trackLogoId.showRaceCourseLogoTitleIds;
            this.showRaceCourseLogoTitle = showRaceCourseLogoTitleIds.indexOf(parseInt(raceTrackAssetId, 10)) > -1;
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    h1{
        margin: 0;
    }

    p {
        line-height: 1.2rem;
    }

    h1 {
        font-weight: bold;
        font-size: 1.4rem;
    }

    span {
        font-size: 0.75rem;
    }

    .card {
        background-color: rgba(255, 255, 255, 0.85);
        border-radius: 6px;
        border: solid 1px black;
        padding: 1.3rem !important;
         -webkit-animation: fadein 3.5s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 3.5s; /* Firefox < 16 */
        -ms-animation: fadein 3.5s; /* Internet Explorer */
         -o-animation: fadein 3.5s; /* Opera < 12.1 */
            animation: fadein 3.5s;
    }

    .race-track-card-text {
        color: black;
    }

    .race-date-time {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        line-height: 1.4rem;
    }

    .race-track-icon {
        width: 3rem !important;
    }

    .home-button {
        color: #000000;
        border: solid 2px black;
        border-radius: 3px !important;
        background: white;
        font-size: 0.5rem;
        font-weight: bold;
    }
/* For the fade animation on the cards*/
  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
    .race-course-logo-title-wrapper{
        width: 100%;
        position: relative;
        padding-bottom: 12%;
    }

    .race-course-logo-title{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
    }

    .race-track-image-wrapper{
        width: 100%;
        padding-bottom: 95%;
        position: relative;
    }

    .race-track-image{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .race-track-main-title{
        position: absolute;
    }

    .ButtonPdf{
        margin-top: 2pt;
    }

    @media (min-width: 1200px) {
        .home-button {
            font-size: 1rem !important;
        }
    }

    
    @media (min-width: 768px) {
        h1 {
            font-size: 1.8rem !important;
        }

        span {
            font-size: 1.1rem !important;
        }

        .card {
            padding: 0.2rem 1rem 1.5rem 1.5rem !important;
        }

        .home-button {
            font-size: 0.7rem;
        }
    }

    @media (min-width: 576px) {
        .race-track-title {
            text-align: center;
        }
    }

</style>
